import { useState } from 'react';
import { Button } from '@accure/ui';
import { useBoolean } from 'usehooks-ts';

import { CreateUserDialog } from '../components/create-user-dialog';
import { type User } from '../entities/user';

import { DeleteUserConfirmationDialog } from './delete-user-confirmation-dialog';
import { EditUserDialog } from './edit-user-dialog';
import { UserTable } from './users-table';

export function UsersManagement() {
  const createUserDialog = useBoolean(false);
  const [deleteUserDialog, setDeleteUserDialog] = useState<User | undefined>(
    undefined,
  );
  const [editUserDialog, setEditUserDialog] = useState<User | undefined>(
    undefined,
  );

  return (
    <div className="space-y-4">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="space-y-2">
          <h1 className="text-xl font-semibold tracking-tight sm:text-2xl">
            User Management
          </h1>
          <p className="text-sm text-muted-foreground sm:text-base">
            Manage users and roles in your organisation
          </p>
        </div>
        <Button
          size="sm"
          className="w-full bg-primary-500 px-4 text-white transition-colors hover:bg-primary-400 sm:w-auto"
          onClick={createUserDialog.setTrue}
        >
          Create User
        </Button>
      </div>

      <div className="space-y-4">
        <div className="rounded-md border">
          <div className="relative w-full">
            <UserTable
              onEditUser={(user) => setEditUserDialog(user)}
              onDeleteUser={(user) => setDeleteUserDialog(user)}
            />
          </div>
        </div>
      </div>

      <CreateUserDialog
        open={createUserDialog.value}
        onClose={createUserDialog.setFalse}
      />

      <EditUserDialog
        user={editUserDialog}
        onClose={() => setEditUserDialog(undefined)}
      />

      <DeleteUserConfirmationDialog
        user={deleteUserDialog}
        onClose={() => setDeleteUserDialog(undefined)}
      />
    </div>
  );
}
